import React from "react";
import { Box, SvgIcon } from "@mui/material";

export const PrimaryArrowIcon = ({ rotate = 0, ...props }) => (
    <Box sx={{
        width: '12px',
        height: '12px',
        borderRadius: '6.2px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}>
        <SvgIcon
            viewBox="0 0 12 12"
            sx={{
                height: '12px',
                width: 'auto',
                transform: `rotate(${rotate}deg)`,  // Rotate the icon based on the `rotate` prop
                ...props
            }}
        >
            <path
                d="M3 10.8817C3 10.9292 3.0334 10.9719 3.08627 10.9909C3.13915 11.0099 3.19759 10.9981 3.23655 10.9648L8.95826 6.08194C8.98609 6.05819 9 6.02731 9 5.99881C9 5.97031 8.98609 5.93706 8.95826 5.91569L3.23933 1.03519C3.20315 1.00194 3.14193 0.990068 3.08627 1.00907C3.03339 1.02807 3 1.07082 3 1.11831L3 10.8817Z"
                fill="#494949"
            />
        </SvgIcon>
    </Box>
);

